// Clarté Paris — Theme JS

document.addEventListener('DOMContentLoaded', function () {

  // ─── Mobile menu toggle ───
  const menuBtn = document.querySelector('.mobile-menu-btn');
  const mobileMenu = document.querySelector('.mobile-menu');
  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', () => {
      mobileMenu.classList.toggle('is-open');
    });
  }

  // ─── Add to cart ───
  const addToCartForm = document.querySelector('.product-form');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', async function (e) {
      e.preventDefault();
      const btn = this.querySelector('.add-to-cart');
      const originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      try {
        const formData = new FormData(this);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        if (response.ok) {
          btn.textContent = 'Added';
          setTimeout(() => {
            btn.textContent = originalText;
            btn.disabled = false;
            updateCartCount();
          }, 1600);
        }
      } catch (err) {
        btn.textContent = originalText;
        btn.disabled = false;
      }
    });
  }

  // ─── Update cart count ───
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const countEl = document.querySelector('.cart-count');
      if (countEl) {
        countEl.textContent = cart.item_count;
        countEl.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
      }
    } catch (e) {}
  }
  updateCartCount();

  // ─── Product image gallery ───
  const thumbs = document.querySelectorAll('.product-thumb');
  const mainImage = document.querySelector('.product-main-image');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      if (mainImage) mainImage.src = thumb.dataset.src;
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  // ─── Animate on scroll ───
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.product-card, .feature-item').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(16px)';
    el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
    observer.observe(el);
  });

});
document.addEventListener('DOMContentLoaded', function () {
  const gallery = document.querySelector('.product-gallery');
  if (!gallery) return;

  const slides = gallery.querySelectorAll('.product-gallery-slide');
  const prevBtn = gallery.querySelector('.prev');
  const nextBtn = gallery.querySelector('.next');

  if (!slides.length) return;

  let currentIndex = 0;

  function showSlide(index) {
    slides.forEach((slide, i) => {
      slide.classList.toggle('active', i === index);
    });
  }

  prevBtn?.addEventListener('click', function () {
    currentIndex = (currentIndex - 1 + slides.length) % slides.length;
    showSlide(currentIndex);
  });

  nextBtn?.addEventListener('click', function () {
    currentIndex = (currentIndex + 1) % slides.length;
    showSlide(currentIndex);
  });

  showSlide(currentIndex);
});

// ─── Search drawer ───
document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector('.header-search-toggle');
  const drawer = document.querySelector('.search-drawer');
  const overlay = document.querySelector('.search-drawer-overlay');
  const closeBtn = document.querySelector('.search-drawer-close');
  const input = document.querySelector('.search-form-input');

  if (!toggle || !drawer || !overlay) return;

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    setTimeout(() => { if (input) input.focus(); }, 200);
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
  }

  toggle.addEventListener('click', openDrawer);
  overlay.addEventListener('click', closeDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });
});